import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=1208465b&scoped=true"
import script from "./PersonList.vue?vue&type=script&lang=js"
export * from "./PersonList.vue?vue&type=script&lang=js"
import style0 from "@/styles/_person_list.scss?vue&type=style&index=0&id=1208465b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208465b",
  null
  
)

export default component.exports